import React, { Component } from 'react';
import cx from 'classnames';

import TranslatedCopy from '../../intl/translated-copy';

class Button extends Component {
  static defaultProps = {
    block: false,
    btnType: 'button',
    copyID: 'APP_SUBMIT',
    disabled: false,
    error: false,
    filled: false,
    filledRed: false,
    filledWhite: false,
    isLoading: false,
    outlineWhite: false,
    success: false,
    visuallyDisabled: false,
    extraClass: false,
    isHidden: false,
  }

  constructor() {
    super();

    this.handleBtnClick = this.handleBtnClick.bind(this);
    this.handleBtnFocus = this.handleBtnFocus.bind(this);
  }

  render() {
    const {
      arrow,
      block,
      btnType,
      className,
      disabled,
      error,
      filled,
      filledRed,
      filledWhite,
      isLoading,
      outlineWhite,
      size,
      success,
      tabIndex,
      extraClass,
      visuallyDisabled,
      isHidden,
    } = this.props;

    const btnClasses = cx({
      'Btn': true,
      'Btn--arrowLeft': arrow === 'left',
      'Btn--arrowRight': arrow === 'right',
      'Btn--block': block,
      'Btn--error': error,
      'Btn--filled': filled,
      'Btn--filledRed': filledRed,
      'Btn--filledWhite': filledWhite,
      'Btn--large': size === 'large',
      'Btn--outlineWhite': outlineWhite,
      'Btn--small': size === 'small',
      'Btn--xSmall': size === 'xSmall',
      'Btn--success': success,
      'CubaDestinationModal-btnColor': extraClass,
      'is-disabled': disabled || visuallyDisabled,
      'isHidden': isHidden,
    }, className);

    return (
      <button
        aria-disabled={ disabled }
        className={ btnClasses }
        disabled={ disabled || isLoading }
        onClick={ this.handleBtnClick }
        onFocus={ this.handleBtnFocus }
        tabIndex={ tabIndex }
        type={ btnType }>
        { this.renderBtnCopy() }
      </button>
    );
  }

  renderBtnCopy() {
    const { copyID, labelEl } = this.props;
    return labelEl ? labelEl : <TranslatedCopy copyID={ copyID } spaceBefore={true} />;
  }

  /**
   * Executes function on button click
   */
  handleBtnClick(e) {
    const {
      disabled,
      onBtnClick,
    } = this.props;

    if (disabled || !onBtnClick) { return; }

    onBtnClick(e);
  }

  /**
   * Executes on button focus
   */
  handleBtnFocus(e) {
    const {
      disabled,
      onBtnFocus,
    } = this.props;

    if (disabled || !onBtnFocus) { return; }

    onBtnFocus(e);
  }
}

export default Button;
